import { render } from "./ProductDetailMinimalStock.vue?vue&type=template&id=3aca9d14&scoped=true&ts=true"
import script from "./ProductDetailMinimalStock.vue?vue&type=script&lang=ts"
export * from "./ProductDetailMinimalStock.vue?vue&type=script&lang=ts"

import "./ProductDetailMinimalStock.vue?vue&type=style&index=0&id=3aca9d14&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aca9d14"]])

export default __exports__